// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutCompany_container_3awwJ"};